export default class SimulatorOfficialQuestion {
    constructor(options) {
        Object.assign(this, options)
    }

    toSend() {
        return {
            id: this.id,
            sort: this.sort,
            description: this.description,
        }
    }
}